let loading;
const $loading = {
  target: loading,
  status: false,
  show(text) {
    loading = weui.loading(text, {
      className: 'custom-classname',
    });
    this.status = true;
  },
  hide() {
    loading.hide();
    this.status = false;
  },
};

export default $loading;
